import toNow from 'date-fns/distance_in_words_to_now';
import {DateTime} from 'luxon';
import i18n from "../locale/i18";

export default (date: string, locale: any, converterOptions: any) => {
  const { includeSeconds, addSuffix = true } = converterOptions

  if ((Math.abs(DateTime.fromISO(date).diffNow('seconds').seconds)) <= 60) {
      return i18n.tc('common.lessAMinute');
  }
  
  return toNow(date, {
    locale,
    includeSeconds,
    addSuffix
  })
}
